import React from 'react';
import styles from '../Chat.module.css';

/**
 * Card for anything that opens inside Lodgeic: pasted app links, shared
 * report views, shared AI conversations. Same frame as a link preview, with
 * the Lodgeic mark and an "Open" action in the footer.
 */
export default function AppCard({ title, subtitle, footNote, action, onOpen, disabled = false, children }) {
  return (
    <div className={styles.appCard}>
      <div className={styles.appCardHead}>
        <span className={styles.appMark} aria-hidden="true"><span /><span /><span /></span>
        <span className={styles.appCardText}>
          <span className={styles.appCardTitle} title={title}>{title}</span>
          {subtitle && <span className={styles.appCardSub}>{subtitle}</span>}
        </span>
      </div>
      {children}
      <div className={styles.appCardFoot}>
        <span style={{ minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{footNote}</span>
        {action && (
          <button type="button" className={styles.appCardOpen} onClick={onOpen} disabled={disabled} style={disabled ? { color: 'var(--lodge-onyx-500)', cursor: 'default' } : undefined}>
            {action}
          </button>
        )}
      </div>
    </div>
  );
}
